import React, { useState } from 'react';
import { Typography, Form, Input, Button } from 'antd';
import { CardStyle } from './AuthLayout';
import { toast } from 'react-toastify';
import { ForgetPasswordApi } from '../../services/api_collection';
import { useNavigate } from 'react-router-dom';

const { Title, Text } = Typography;

const ForgetPassword = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (values) => {
    setLoading(true);
    try {
      const payload = {
        email: values.confirmMail
      };
      const res = await ForgetPasswordApi(payload);
      if (res.statusCode === 200) {
        toast.success(res?.message);
        navigate('/');
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      toast.error('Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <CardStyle>
      <div>
        <Title
          level={1}
          style={{
            fontSize: '48px',
            lineHeight: '50px',
            fontWeight: 700,
            margin: 0
          }}>
          Forgot Your Password
        </Title>
        <Text style={{ fontSize: '16px', color: '#767676' }}>
          We&apos;ll send you a link to reset your password.
        </Text>
      </div>
      <Form form={form} onFinish={onSubmit} layout="vertical">
        <Form.Item
          label={<Text style={{ fontSize: '16px', fontWeight: 400 }}>Email</Text>}
          name="confirmMail"
          required={false}
          rules={[
            { required: true, message: 'Email is required' },
            {
              pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
              message: 'Enter a valid email address'
            }
          ]}>
          <Input
            placeholder="Enter email"
            size="large"
            style={{
              height: '47px',
              borderRadius: '8px',
              fontSize: '16px'
            }}
          />
        </Form.Item>
        <Form.Item style={{ margin: 0 }}>
          <Button loading={loading} htmlType="submit" type="primary" className="buttonStyle">
            Send Reset Instructions
          </Button>
        </Form.Item>
      </Form>
    </CardStyle>
  );
};

export default ForgetPassword;
